import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CompoundCardComponent } from '@apps/landing/src/app/shared/components/cards/compound-card/compound-card.component';
import { ImageCardComponent } from '@apps/landing/src/app/shared/components/cards/image-card/image-card.component';
import { InfoCardComponent } from '@apps/landing/src/app/shared/components/cards/info-card/info-card.component';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { SectionHeaderComponent } from '../../shared/components/section-header/section-header.component';
import { SharedModule } from '../../shared/shared.module';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';
import {
  contactInfoItems,
  particularities,
  skills,
  technologiesDetails,
  workWithUsItems,
} from '@apps/landing/src/app/modules/home/utils/constants';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-home',
  imports: [
    SharedModule,
    HlmButtonDirective,
    SectionHeaderComponent,
    InfoCardComponent,
    ImageCardComponent,
    CompoundCardComponent,
    NgOptimizedImage,
  ],
  templateUrl: './home.component.html',
  standalone: true,
})
export class HomeComponent {
  private readonly router = inject(Router);

  protected technologiesDetails: any[] = technologiesDetails;
  protected readonly workWithUsItems = workWithUsItems;
  protected readonly particularities: any[] = particularities;
  protected readonly skills = skills;
  protected readonly contactInfoItems = contactInfoItems;

  protected readonly imageLoaded = signal(false);

  ngOnInit() {
    this.technologiesDetails = this.technologiesDetails.map(item => ({
      ...item,
      floatDuration: this.getRandomDuration(),
    }));
  }

  private getRandomDuration(): string {
    const minSeconds = 3;
    const maxSeconds = 7;
    const randomSeconds = Math.random() * (maxSeconds - minSeconds) + minSeconds;

    return `${randomSeconds.toFixed(2)}s`;
  }

  protected redirectToHireUs() {
    this.router.navigate([PAGE_ROUTES.HIRE_US]);
  }

  protected redirectToServices() {
    this.router.navigate([PAGE_ROUTES.SERVICES]);
  }
}
